import React from "react";
import "./GloboContacto.Module.css";
import botonContacto from "../../assets/svg-redes/BOTON_CONTACTO.png";

function GloboContacto({ posicion }) {
  const [respira, setRespira] = React.useState(false);

  React.useEffect(() => {
    const interval = setInterval(() => {
      setRespira((prev) => !prev);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const whatsappLink =
    "https://api.whatsapp.com/send?phone=+54341514700&text=Hola%20Marketina,%20te%20escribo%20desde%20la%20p%C3%A1gina%20web,%20necesito%20asesoramiento.";

  return (
    <div
      className={`${posicion === "derechaButton" ? "derechaButton" : "fixedGlobo"}`}
    >
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="botonGloboLink"
        aria-label="Abrir WhatsApp"
      >
        <div className={`imgBotonGlobo ${respira ? "respira" : ""}`}>
          {/* Texto curvo */}
          <svg
            className="curvedText"
            viewBox="0 0 100 100"
            aria-hidden="true"
          >
            <defs>
              <path
                id="circlePath"
                d="M 50,50 m -38,0 a 38,38 0 1,1 76,0 a 38,38 0 1,1 -76,0"
              />
            </defs>

            <text>
              <textPath
                href="#circlePath"
                startOffset="50%"
                textAnchor="middle"
              >
                ESCRIBINOS
              </textPath>
            </text>
          </svg>

          <img src={botonContacto} alt="Botón WhatsApp" />
        </div>
      </a>
    </div>
  );
}

export default GloboContacto;
